// extracted by mini-css-extract-plugin
export var bothNarrow = "SimpleHeader-module--bothNarrow--1b921";
export var contrasted = "SimpleHeader-module--contrasted--12c77";
export var cta = "SimpleHeader-module--cta--0f787";
export var header = "SimpleHeader-module--header--e4c5d";
export var horizontalDash = "SimpleHeader-module--horizontalDash--6d171";
export var label = "SimpleHeader-module--label--23c48";
export var lg = "SimpleHeader-module--lg--53e3f";
export var root = "SimpleHeader-module--root--14189";
export var subtitle = "SimpleHeader-module--subtitle--abd6b";
export var subtitleNarrow = "SimpleHeader-module--subtitleNarrow--7b6bb";
export var title = "SimpleHeader-module--title--6b079";
export var titleNarrow = "SimpleHeader-module--titleNarrow--4fd1c";
export var verticalDash = "SimpleHeader-module--verticalDash--464c9";
export var wrapper = "SimpleHeader-module--wrapper--79694";
export var xl = "SimpleHeader-module--xl--126ac";
export var xxl = "SimpleHeader-module--xxl--f95b0";